import { Task } from "./task";
import { Identifiable } from "./identifiable";
import { Milestone } from "./milestone";

type ProjectSynthesis = {
  upComingMilestones: Identifiable<Milestone>[];
  upComingTasks: Identifiable<Task>[];
  delayedMilestones: Identifiable<Milestone>[];
  finishedMilestones: Identifiable<Milestone>[];
  delayedTasks: Identifiable<Task>[];
  upComingElementsNbr: number;
  delayedElementsNbr: number;
  doneMilestonesNbr: number;
  doneTasksNbr: number;
  workedHours: number;
  delayedWorkHours: number;
  openedWorkHours: number;
  milestonesNbr: number;
  tasksNbr: number;
  proportionOfAccomplishedWork: number;
  proportionOfDelayedWork: number;
  proportionOfOpenedWork: number;
  totalOfTimesSpentInProject: number;
  allocatedTime: number;
  totalOfRemainingTimeInProject: number;
};

const projectSynthesis: ProjectSynthesis = {
  upComingMilestones: [],
  finishedMilestones: [],
  upComingTasks: [],
  delayedMilestones: [],
  delayedTasks: [],
  upComingElementsNbr: 0,
  delayedElementsNbr: 0,
  doneMilestonesNbr: 0,
  doneTasksNbr: 0,
  workedHours: 0,
  delayedWorkHours: 0,
  openedWorkHours: 0,
  milestonesNbr: 0,
  tasksNbr: 0,
  proportionOfAccomplishedWork: 0,
  proportionOfDelayedWork: 0,
  proportionOfOpenedWork: 0,
  totalOfTimesSpentInProject: 0,
  allocatedTime: 0,
  totalOfRemainingTimeInProject: 0,
};

export type { ProjectSynthesis };

export { projectSynthesis };
